<template>
  <div class="pager">
    <!-- 平台备注弹窗 -->
    <el-dialog title="备注详情" :visible.sync="noteVisible" width="450">
      <div style="white-space:pre-wrap;">{{ currentNote || "" }}</div>
      <div slot="footer">
        <el-button @click="noteVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <div class="top">
      <div class="querybox">
        <div class="qitem qitem-lg">
          <p>rom类型：</p>
          <el-select v-model="queryParams.romType" placeholder="请选择" clearable>
            <el-option v-for="item in getDictDatas(DICT_TYPE.ROM_TYPE)" :key="item.value" :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="qitem qitem-lg">
          <p>游戏类型：</p>
          <el-select v-model="queryParams.romGameType" placeholder="请选择" clearable>
            <el-option v-for="item in getDictDatas(DICT_TYPE.ROM_GAME_TYPE)" :key="item.value" :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="qitem qitem-md">
          <p>名字：</p>
          <el-input v-model="queryParams.romName" placeholder="请输入名字" clearable></el-input>
        </div>
        <div class="qitem qitem-sm">
          <p>热门：</p>
          <el-select v-model="queryParams.isHot" placeholder="全部" clearable>
            <el-option v-for="item in yesNoOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="qitem qitem-sm">
          <p>推荐：</p>
          <el-select v-model="queryParams.isRecommend" placeholder="全部" clearable>
            <el-option v-for="item in yesNoOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="qitem qitem-sm">
          <p>双人：</p>
          <el-select v-model="queryParams.isDouble" placeholder="全部" clearable>
            <el-option v-for="item in yesNoOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="handlebox">
        <div class="btnbox">
          <el-button type="primary" icon="el-icon-search" class="search-btn" @click="search">查询</el-button>
          <el-button type="primary" icon="el-icon-refresh-right" class="reset-btn" @click="resetFn">重置</el-button>
          <el-button icon="el-icon-plus" class="add-btn" @click="addRom">添加</el-button>
          <el-popconfirm icon="el-icon-info" icon-color="red" title="确认删除选中的rom吗？" popper-class="customerdel-popover"
            @confirm="deleteFn()">
            <el-button slot="reference" icon="el-icon-delete" class="add-btn">删除</el-button>
          </el-popconfirm>
        </div>
      </div>
    </div>
    <div class="content">
      <el-table :data="tableData" tooltip-effect="dark" :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }" show-overflow-tooltip @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="50"> </el-table-column>
        <el-table-column prop="romIcon" label="rom图标">
          <template slot-scope="{ row }">
            <div class="logo">
              <el-image :src="row.romIcon" :preview-src-list="[row.romIcon]" fit="contain"
                style="width: 55%; height: 36px;" />
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="romName" label="名字(中文)" min-width="120">
        </el-table-column>

        <el-table-column prop="romNameEn" label="名字(英文)" min-width="120">
        </el-table-column>

        <el-table-column prop="romType_dictText" label="rom类型" min-width="60">
        </el-table-column>

        <el-table-column prop="romGameType_dictText" label="游戏类型" min-width="60">
        </el-table-column>

        <el-table-column label="推荐" width="64">
          <template slot-scope="{ row }">
            <i v-if="Number(row.isRecommend) === 1" class="el-icon-check flag-yes"></i>
            <i v-else class="el-icon-close flag-no"></i>
          </template>
        </el-table-column>

        <el-table-column label="热门" width="64">
          <template slot-scope="{ row }">
            <i v-if="Number(row.isHot) === 1" class="el-icon-check flag-yes"></i>
            <i v-else class="el-icon-close flag-no"></i>
          </template>
        </el-table-column>

        <el-table-column label="双人" width="64">
          <template slot-scope="{ row }">
            <i v-if="Number(row.isDouble) === 1" class="el-icon-check flag-yes"></i>
            <i v-else class="el-icon-close flag-no"></i>
          </template>
        </el-table-column>

        <el-table-column label="支持平台" min-width="160">
          <template slot-scope="scope">
            <span v-if="!scope.row.romPlatformListRes || scope.row.romPlatformListRes.length === 0">暂无</span>
            <template v-else>
              <div v-for="(platformItem, index) in scope.row.romPlatformListRes" :key="index"
                style="display:inline-block;margin-right:4px;cursor:pointer;" @click="openNote(platformItem)">
                <el-tag size="mini"
                  :type="platformItem.status === 1 || platformItem.notes === '待核验' ? 'danger' : 'success'"
                  style="margin-right:4px;">
                  {{ platformItem.romSupportedPlatform_dictText }}
                </el-tag>
              </div>
            </template>
          </template>
        </el-table-column>

        <el-table-column label="操作" min-width="120">
          <template slot-scope="scope">
            <el-button class="textOrange-btn" @click="goEdit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <pagination v-show="total > queryParams.pageSize" :total="total" :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize" @pagination="init" />
    </div>
  </div>
</template>

<script>
import { getRomsList, editRomStatus, deleteRoms } from "@/api/simulator";
export default {
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        romType: "",
        romGameType: "",
        romName: "",
        isHot: "",
        isRecommend: "",
        isDouble: "",
      },
      // 是否类筛选项（0:否 1:是）
      yesNoOptions: [
        { label: "是", value: 1 },
        { label: "否", value: 0 },
      ],
      tableData: [],
      total: 0, //总数
      selectList: [],
      romSupportedPlatformList: [],
      noteVisible: false,
      currentNote: ""
    };
  },
  async created() {
    // 从编辑页返回时还原筛选条件和页码
    const q = this.$route.query;
    if (q.page) this.queryParams.pageNum = Number(q.page) || 1;
    if (q.romType !== undefined && q.romType !== "") {
      this.queryParams.romType = Number(q.romType);
    }
    if (q.romGameType !== undefined && q.romGameType !== "") {
      this.queryParams.romGameType = Number(q.romGameType);
    }
    if (q.romName !== undefined) {
      this.queryParams.romName = q.romName;
    }
    if (q.isHot !== undefined && q.isHot !== "") {
      this.queryParams.isHot = Number(q.isHot);
    }
    if (q.isRecommend !== undefined && q.isRecommend !== "") {
      this.queryParams.isRecommend = Number(q.isRecommend);
    }
    if (q.isDouble !== undefined && q.isDouble !== "") {
      this.queryParams.isDouble = Number(q.isDouble);
    }

    this.init();
  },
  mounted() {
  },
  methods: {
    // 把当前筛选条件写进路由，供编辑页返回时还原
    buildQuery() {
      const q = {};
      const p = this.queryParams;
      if (p.pageNum) q.page = p.pageNum;
      if (p.romType !== "" && p.romType != null) q.romType = p.romType;
      if (p.romGameType !== "" && p.romGameType != null) {
        q.romGameType = p.romGameType;
      }
      if (p.romName) q.romName = p.romName;
      if (p.isHot !== "" && p.isHot != null) q.isHot = p.isHot;
      if (p.isRecommend !== "" && p.isRecommend != null) {
        q.isRecommend = p.isRecommend;
      }
      if (p.isDouble !== "" && p.isDouble != null) q.isDouble = p.isDouble;
      return q;
    },

    //获取roms列表
    async init() {
      const res = await getRomsList(this.queryParams);
      this.tableData = res.result.records;
      this.total = res.result.total;

      const maxPage = Math.ceil(this.total / this.queryParams.pageSize) || 1;
      if (this.queryParams.pageNum > maxPage) {
        this.queryParams.pageNum = maxPage;
        this.init();
      }
    },

    // 打开备注
    openNote(item) {
      this.currentNote = item.notes;
      this.noteVisible = true;
    },
    // 查询
    search() {
      this.queryParams.pageNum = 1;
      this.init();
    },
    //重置
    resetFn() {
      this.queryParams.romType = "";
      this.queryParams.romGameType = "";
      this.queryParams.romName = "";
      this.queryParams.isHot = "";
      this.queryParams.isRecommend = "";
      this.queryParams.isDouble = "";
      // this.queryParams.pageNum = 1;
      this.init();
    },
    // 去添加
    addRom() {
      this.$router.push({
        path: "/addRom",
        query: {
          type: "add",
          ...this.buildQuery(),
        },
      });
    },
    // 去修改
    goEdit(item) {
      this.$router.push({
        path: "/addRom",
        query: {
          type: "edit",
          id: item.id,
          ...this.buildQuery(),
        },
      });
    },
    //修改rom状态
    async cancelOrder(item, status) {
      const params = {
        status,
        id: item.id,
      };
      await editRomStatus(params);
      // this.$refs[`${text}-popover-${index}`].doClose();
      this.init();
    },
    // 选择
    handleSelectionChange(val) {
      this.selectList = val.map((el) => {
        return el.id;
      });
    },
    // 删除
    async deleteFn() {
      if (this.selectList.length === 0) {
        this.$message.error("请先选择要删除的rom");
        return;
      }
      await deleteRoms(this.selectList);
      this.$message.success("删除成功");
      this.init();
    },
  },
};
</script>
<style lang="scss" scoped>
.pager {
  .top {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding-bottom: 16px;

    ::v-deep .querybox {
      flex: 1;
      min-width: 0;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      column-gap: 20px;
      row-gap: 12px;
      grid-auto-rows: 32px;

      .qitem {
        display: flex;
        align-items: center;
        min-width: 0;

        p {
          flex: 0 0 68px;
          margin-right: 8px;
          text-align: right;
          font-weight: 400;
          font-size: 13px;
          color: #262626;
          line-height: 32px;
          white-space: nowrap;
        }

        .el-select,
        .el-input {
          flex: 1;
          min-width: 0;
        }

        input::-webkit-input-placeholder {
          /* WebKit browsers */
          color: rgba(0, 0, 0, 0.25);
        }

        .el-input__inner {
          height: 32px;
          line-height: 32px;
          background: #ffffff;
          border-radius: 4px;
          border: 1px solid #d9d9d9;
          font-size: 13px;
        }

        .el-select .el-input__icon {
          line-height: 32px;
        }
      }
    }

    .handlebox {
      flex-shrink: 0;
      margin-left: 24px;

      .btnbox {
        display: grid;
        grid-template-columns: repeat(2, 95px);
        grid-auto-rows: 32px;
        gap: 12px;
        width: 202px;

        ::v-deep .el-button {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 32px;
          padding: 0;
          margin: 0;
          line-height: 1;
          font-size: 13px;
          border-radius: 4px;
        }
      }
    }
  }

  .content {
    ::v-deep .el-table {
      th,
      td {
        padding: 6px 0;
      }

      .cell {
        padding: 0 8px;
        font-size: 13px;
        line-height: 1.4;
      }
    }

    .logo {
      display: flex;
      justify-content: center;
      border-radius: 10px;

      img {
        width: 60%;
        border-radius: 4px;
      }

      ::v-deep .el-image {
        border-radius: 4px;
        overflow: hidden;
      }
    }

    .textOrange-btn {
      margin: 0 10px;
      font-size: 13px;
    }

    .flag-yes {
      color: #52c41a;
      font-size: 16px;
      font-weight: 600;
    }

    .flag-no {
      color: #ff4d4f;
      font-size: 16px;
    }

    ::v-deep .is-checked {
      .el-checkbox__inner {
        background-color: #ff5d2f;
        border-color: #ff5d2f;
      }
    }

    ::v-deep .is-indeterminate {
      .el-checkbox__inner {
        background-color: #ff5d2f;
        border-color: #ff5d2f;
      }
    }

    ::v-deep .el-checkbox__inner {
      width: 16px;
      height: 16px;
    }
  }
}
</style>
